module.exports = __webpack_public_path__ + "static/media/maui.615f6083.jpeg";